/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_EditInputs */

const fr_vehicle_action_edit = /** @type {(inputs: Vehicle_Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditer`)
};

const en_vehicle_action_edit = /** @type {(inputs: Vehicle_Action_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Vehicle_Action_EditInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit = /** @type {((inputs?: Vehicle_Action_EditInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_EditInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit(inputs)
	return en_vehicle_action_edit(inputs)
});